import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, mapProps, branch, renderNothing } from 'recompose'
import parseUserAgent from 'user-agent-parser'
import cx from 'classnames'

import * as MessageSelectors from 'app/modules/message/selectors'

import { Icon } from '@driftt/tide-core-legacy'

import * as style from './style'

class ConversationSection extends Component {
  getFormattedUserAgentString = (ua) => {
    const browserString = _.compact([
      _.get(ua, 'browser.name'),
      _.get(ua, 'browser.version'),
    ]).join(' ')

    const osString = _.compact([
      _.get(ua, 'os.name'),
      _.get(ua, 'os.version'),
    ]).join(' ')

    return _.compact([
      browserString,
      osString,
    ]).join(' / ')
  }

  render() {
    const {
      className,
      ip,
      url,
      ua,
    } = this.props

    const userAgentString = this.getFormattedUserAgentString(ua)

    return(
      <div className={cx(style.conversationSection, className)}>
        <div className="section-header">
          <Icon name="chat-1" className="header-icon"/>
          <span className="section-title">
            Conversation Details
          </span>
        </div>
        <div className="section-body">
          <div className="body-row">
            <div className="row-header">
              Conversation Started From
            </div>
            <div className="row-body">
              {url ? <a href={url}>{url}</a> : '-'}
            </div>
          </div>
          <div className="body-row">
            <div className="row-header">
              Web Browser and Device
            </div>
            <div className="row-body">
              {!!userAgentString ? userAgentString : '-'}
            </div>
          </div>
          <div className="body-row">
            <div className="row-header">
              IP Address
            </div>
            <div className="row-body">
              {ip ? ip : '-'}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const firstEndUserMessageSelector = MessageSelectors.firstEndUserMessage()

  return (state, props) => {
    const { conversationId } = props

    return {
      firstEndUserMessage: firstEndUserMessageSelector(state, { conversationId })
    }
  }
}

export default compose(
  connect(makeMapStateToProps),
  branch(props => !props.firstEndUserMessage, renderNothing),
  mapProps(({ firstEndUserMessage, ...props }) => {
    const userAgent = firstEndUserMessage.getIn(['context', 'userAgent'])
    let ua = userAgent && parseUserAgent(userAgent)

    // edge case: the IE11 UA story
    // https://blogs.msdn.microsoft.com/ieinternals/2013/09/21/internet-explorer-11s-many-user-agent-strings/
    if (_.get(ua, 'browser.name') && _.get(ua, 'engine.name') === 'Trident') {
      ua.browser = { name: 'Internet Explorer', version: 11 }
    }

    return {
      ip: firstEndUserMessage.getIn(['context', 'ip']),
      url: firstEndUserMessage.getIn(['context', 'page', 'href']),
      ua,
      ...props,
    }
  }),
)(ConversationSection)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/ConversationSection/index.js